<template>
  <span>
    <div class="container_selection"
         v-if="!formSelected && !pollSelected && !multiSelect && !singleSelect && !textField">
      <Card
        :class="{'container_selection-single' : !this.isAdmin && !this.$isYSC}"
        icon="fal fa-poll-people fa-6x"
        title="Poll"
        :text="this.pContent"
        :selection="this.getPollSelectedField"
      />
      <Card
        v-if="this.isAdmin || this.$isYSC"
        icon="fal fa-file-alt fa-6x"
        title="Form"
        :text="this.fContent"
        :selection="this.getPollSelectedField"
      />
    </div>
    <div class="container_selection" v-if="formSelected">
      <Card
          icon="fal fa-ballot-check fa-4x"
          title="Single Select"
          :selection="this.getPollSelectedField"
      />
      <Card
          icon="fal fa-tasks fa-4x"
          title="Multi Select"
          :selection="this.getPollSelectedField"
      />
      <Card
          icon="far fa-text fa-4x"
          title="Text Field"
          :selection="this.getPollSelectedField"
      />
    </div>
    <!-- Show Poll-->
    <poll v-if="pollSelected"
          type="poll"
          :poll="poll"
          :pollOptions="pollOptions"
          :deletePollOption="deletePollOption"
          :addPollOption="addPollOption" />
    <!-- Show TextField -->
    <poll v-if="textField"
          type="textField"
          :poll="poll"
          :pollOptions="pollOptions"
          :deletePollOption="deletePollOption"
          :addPollOption="addPollOption" />
    <!-- Show Single Select   -->
    <span v-if="isPhone && (singleSelect || multiSelect)">
      <p>Please use landscape</p>
      <span class="landscape_container">
        <i class="fas fa-mobile-alt fa-8x landscape"/>
      </span>
    </span>
    <span v-else>
      <poll v-if="singleSelect"
            type="singleSelect"
            :poll="poll"
            :pollOptions="pollOptions"
            :deletePollOption="deletePollOption"
            :addPollOption="addPollOption" />
      <!-- Show Multiple Select   -->
      <poll v-if="multiSelect"
            type="multiSelect"
            :poll="poll"
            :pollOptions="pollOptions"
            :deletePollOption="deletePollOption"
            :addPollOption="addPollOption" />
    </span>
  </span>
</template>
<script>
import i18n from '@/i18n'
import Card from './Card'
import Poll from './Poll'
import auth from '@/mixins/auth'

export default {
  mixins: [auth],
  data: function () {
    return {
      pContent: i18n.t('projectPage.pollContent'),
      fContent: i18n.t('projectPage.formContent'),
      isPhone: false
    }
  },
  props: {
    poll: {
      type: Object,
      required: true
    },
    pollOptions: {
      type: Array,
      required: true
    },
    formSelected: {
      type: Boolean,
      required: true
    },
    pollSelected: {
      type: Boolean,
      required: true
    },
    multiSelect: {
      type: Boolean,
      required: true
    },
    singleSelect: {
      type: Boolean,
      required: true
    },
    textField: {
      type: Boolean,
      required: true
    },
    deletePollOption: {
      type: Function,
      required: true
    },
    addPollOption: {
      type: Function,
      required: true
    },
    resetPollSelection: {
      type: Function,
      required: true
    },
    getPollSelectedField: {
      type: Function,
      required: true
    }
  },
  mounted: function () {
    this.resetPollSelection()
    this.getMedia()
    window.addEventListener('orientationchange', this.handleOrientationChange)
  },
  components: {
    Card,
    Poll,
    i18n
  },
  methods: {
    getMedia: function () {
      const portrait = window.matchMedia('(orientation: portrait)').matches
      const deviceWidth = window.matchMedia('only screen and (max-width: 500px)').matches
      if (portrait && deviceWidth) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    handleOrientationChange: function () {
      const orientation = window.screen.orientation.type
      const deviceWidth = window.matchMedia('only screen and (max-width: 500px)').matches
      if (orientation === 'portrait-primary' && deviceWidth) {
        this.isPhone = true
      } else if (orientation === 'landscape-primary' && deviceWidth) {
        this.isPhone = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';
.container {
  &_selection {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @include mobile {
      flex-direction: column;
      align-items: center;
      justify-content: unset;
    }
    &-single {
      flex-direction: column !important;
      margin-left: 9rem;
      @include mobile {
        margin-left: 0;
      }
    }
  }
}

.landscape {
  &_container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 2rem 0;
  }
  -webkit-animation-name: rotate;
  -webkit-animation-duration: 4.5s;
  -webkit-animation-iteration-count: infinite;
  -webkit-transition-timing-function: linear;
}

@-webkit-keyframes rotate {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(90deg); }
}
</style>
